module.exports = __webpack_public_path__ + "static/media/diet.54a6514f.png";